import React from 'react';
import {useStyles} from './helper';

const RTP = ({label, percent}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.label}>{label}</span>
            <span className={classes.percent}>
                {percent}%
            </span>
        </div>
    )
}

export default RTP;